// @core/api/endpoints/booking/list_booking_numbering_schemes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBookingNumberingSchemesResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List numbering schemes
 * Returns booking numbering schemes, optionally filtered by scope.
 */
export async function ListBookingNumberingSchemes(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListBookingNumberingSchemesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/booking-numbering-schemes`;
  const requestOptions = options;
  return client.get<ListBookingNumberingSchemesResponse>(requestPath, { ...requestOptions, params });
}
